import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Products from "@/components/site/Products";
import Process from "@/components/site/Process";
import CaseStudies from "@/components/site/CaseStudies";
import Pricing from "@/components/site/Pricing";
import QuoteForm from "@/components/site/QuoteForm";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#FAFAFA] text-[#0A0A0A]">
      <Nav />
      <Hero />
      <Marquee />
      <Products />
      <Process />
      <CaseStudies />
      <Pricing />
      <QuoteForm />
      <Footer />
    </div>
  );
}
